import store from '@/store'
import Vue from 'vue'
import Router from 'vue-router'
// 只有views底下的才會用在router
import CommissionSearch from '@/views/Commission/CommissionSearch.vue'
import CusAgree from '@/views/cusAgree.vue'
import ErrorMessagePage from '@/views/ErrorMessagePage.vue'
import ErrorPage from '@/views/ErrorPage.vue'
import FormDownload from '@/views/FormDownload/FormDownloadPage.vue'
import Home from '@/views/Home.vue'
import Layout from '@/views/Layout.vue'
import RmwLogin from '@/views/Login/rmw/RmwLogin.vue'
import Login from '@/views/Login/TheLogin.vue'
import { ProposalMain, ProposalRemote, ProposalSearch } from '@/views/Proposal'
import {
  ProposalRemoteSteps,
  ProposalSteps,
  StepAgentFiles,
  StepAttachmentUpload,
  StepCheckItem,
  StepCusInsured,
  StepCusLegalAgent,
  StepCusPolicyHolder,
  StepPolicySignature,
  StepStatement,
  StepWritten
} from '@/views/Proposal/Steps'
import ReleasePermitAudit from '@/views/ReleasePermit/ReleasePermitAudit.vue'
import ReleasePermitInput from '@/views/ReleasePermit/ReleasePermitInput.vue'
Vue.use(Router)
const base = process.env.VUE_APP_BASE_ROUTE || '/'

const unRequireAuth = true // 不需權限

// const isAppDev = (process.env.VUE_APP_DEV_ENV === 'development') || (process.env.NODE_ENV === 'development') || (process.env.VUE_APP_PROD_LOGIN === 'development')
// const isAppDev = true

const LOGIN = {
  path: '/login',
  name: 'login',
  component: Login,
  props: (route) => ({
    showVer: route.query.v,
    resetUserCode: route.query.resetUserCode
  }),
  meta: {
    unRequireAuth
  }
}

const RMWLOGIN = {
  path: '/RMW/api/login/authentication',
  name: '/RMW/api/login/authentication',
  component: RmwLogin,
  meta: {
    unRequireAuth
  }
}

const ERROR = {
  path: '/error',
  name: 'error',
  component: ErrorPage,
  props: true
}

const ERRORMESSAGE = {
  path: '/errorMsg',
  name: 'errorMsg',
  component: ErrorMessagePage,
  props: true,
  meta: {
    unRequireAuth
  }
}

const AGREE = {
  path: '/AGREE',
  name: 'AGREE',
  component: CusAgree,
  props: true,
  meta: {
    unRequireAuth
  }
}

const router = new Router({
  mode: 'history',
  base,
  routes: [
    LOGIN,
    RMWLOGIN,
    ERROR,
    ERRORMESSAGE,
    AGREE,
    {
      path: '*',
      redirect: '/home'
    },
    {
      path: '/',
      name: 'layout',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: 'home',
          name: 'home',
          component: Home
        },
        {
          path: 'proposal',
          name: 'proposal',
          component: ProposalSearch,
          props: true
        },
        {
          path: 'nopage',
          name: 'nopage'
        },
        {// 佣獎查詢
          path: 'commissionSearch',
          name: 'commissionSearch',
          component: CommissionSearch,
          props: true
        },
        { // 攜出名單申請
          path: 'releasePermitAudit',
          name: 'releasePermitAudit',
          component: ReleasePermitAudit
        },
        { // 攜出名單輸入
          path: 'releasePermitInput',
          name: 'releasePermitInput',
          component: ReleasePermitInput,
          props: true
        },
        { // 表單下傳
          path: 'formDownload',
          name: 'formDownload',
          component: FormDownload,
          props: true
        },
        { // 行動投保
          path: '/:enterpoint/proposalMain',
          name: 'proposalMain',
          component: ProposalMain,
          props: true,
          children: [
            {
              path: 'steps',
              name: 'proposalSteps',
              component: ProposalSteps,
              props: true,
              children: [
                {// 要保險人
                  path: 'INS_S1',
                  name: 'INS_S1',
                  component: StepCusPolicyHolder,
                  props: true
                },
                { // 被保險人
                  path: 'INS_S2',
                  name: 'INS_S2',
                  component: StepCusInsured,
                  props: true
                },
                { // 法定代理人
                  path: 'INS_S3',
                  name: 'INS_S3',
                  component: StepCusLegalAgent,
                  props: true
                },
                { // 檢核項目
                  path: 'INS_S4',
                  name: 'INS_S4',
                  component: StepCheckItem,
                  props: true
                },
                { // 附件上傳
                  path: 'INS_S5',
                  name: 'INS_S5',
                  component: StepAttachmentUpload,
                  props: true
                },
                { // 其他聲明事項
                  path: 'INS_S6',
                  name: 'INS_S6',
                  component: StepStatement,
                  props: true
                },
                { // 書面分析資料
                  path: 'INS_S7',
                  name: 'INS_S7',
                  component: StepWritten,
                  props: true
                },
                { // 簽名資料
                  path: 'INS_S8',
                  name: 'INS_S8',
                  component: StepPolicySignature,
                  props: true
                },
                { // 保經表單
                  path: 'INS_S9',
                  name: 'INS_S9',
                  component: StepAgentFiles,
                  props: true
                }
              ]
            }
          ]
        },
        { //遠距投保
          path: '/:enterpoint/proposalRemote',
          name: 'proposalRemote',
          component: ProposalRemote,
          props: true,
          children: [
            {
              path: 'steps',
              name: 'proposalRemoteSteps',
              component: ProposalRemoteSteps,
              props: true,
              children: [
                {// 要保險人
                  path: 'REMOTE_S1',
                  name: 'REMOTE_S1',
                  component: StepCusPolicyHolder,
                  props: true
                },
                { // 被保險人
                  path: 'REMOTE_S2',
                  name: 'REMOTE_S2',
                  component: StepCusInsured,
                  props: true
                },
                { // 法定代理人
                  path: 'REMOTE_S3',
                  name: 'REMOTE_S3',
                  component: StepCusLegalAgent,
                  props: true
                },
                { // 檢核項目
                  path: 'REMOTE_S4',
                  name: 'REMOTE_S4',
                  component: StepCheckItem,
                  props: true
                },
                { // 附件上傳
                  path: 'REMOTE_S5',
                  name: 'REMOTE_S5',
                  component: StepAttachmentUpload,
                  props: true
                },
                { // 書面分析資料
                  path: 'REMOTE_S6',
                  name: 'REMOTE_S6',
                  component: StepWritten,
                  props: true
                },
                { // 保經表單
                  path: 'REMOTE_S7',
                  name: 'REMOTE_S7',
                  component: StepAgentFiles,
                  props: true
                }
              ]
            }
          ]
        },
      ]
    }
  ]
})

/** only for error 401 */
router.goLogin = function (params) {
  this.currentRoute.name !== LOGIN.name &&
    this.replace({
      name: LOGIN.name,
      params
    })
  window.location.reload()
}

router.goErrorMessage = function (params) {
  this.currentRoute.name !== ERRORMESSAGE.name &&
    this.replace({
      name: ERRORMESSAGE.name,
      params
    })
}

router.beforeEach((to, from, next) => {
  const requireAuth = to.matched.some(r => !r.meta.unRequireAuth)
  if (requireAuth) {
    const isLogin = store.getters['user/isLogin']
    if (!isLogin) {
      next({ name: LOGIN.name })
    } else {
      // next()
      store.dispatch('user/checkTabLogin').then(r => {
        if (store.state.user.hadTabLogin) {
          let params = {
            errorMsg: '已於其他分頁登入，無法再開啟新的分頁！'
          }
          router.goErrorMessage(params)
        } else {
          next()
        }
      })
    }
  } else {
    if (to.name === 'login') { // login頁，也要分斷是否是新開分頁。已經login了，不能再做login
      store.dispatch('user/fetchUserInfo').then(() => {
        const isLogin = store.getters['user/isLogin']
        if (isLogin) { // 要通過帳密驗證(已有session)，還有OTP驗證 才會進入首頁
          router.replace('/home')
        } else {
          next()
        }
      })
    } else {
      next()
    }
  }
})

export default router
